import { PopupLovColumnConfig } from '@core/interfaces';

export const columnsDefaultConfig: PopupLovColumnConfig = {
  column1: {
    key: 'column1',
    display: true,
    width: 100,
    class: '',
  },

  // this column automatically sizes to fill
  // any available space by default (width: 0)
  column2: {
    key: 'column2',
    display: true,
    width: 0,
    class: '',
  },

  // all columns after column2 are not displayed by default
  column3: {
    key: 'column3',
    display: false,
    width: 100,
    class: '',
  },
  column4: {
    key: 'column4',
    display: false,
    width: 100,
    class: '',
  },
  column5: {
    key: 'column5',
    display: false,
    width: 100,
    class: '',
  },
};
